import React from 'react';

import s from './imagePlaceholder.scss';

export const ItemImagePlaceholder = React.memo(() => <div className={s.placeholder} />);
